import React, { useState, useEffect } from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import '../styles/List.css';
import ReservationForm from './ReservationForm';
import Events from './Events';
import { TextField, Box, Button, InputAdornment, IconButton } from '@mui/material';
import EventIcon from '@mui/icons-material/Event';
import FilterListIcon from '@mui/icons-material/FilterList';
import {DATA_URL} from "../config";

const formatUTCDate = () => {
  const date = new Date();
  // const day = String(date.getUTCDate()).padStart(2, '0');
  // const month = String(date.getUTCMonth() + 1).padStart(2, '0');
  // const year = date.getUTCFullYear();
  const hours = String(date.getUTCHours()).padStart(2, '0');
  const minutes = String(date.getUTCMinutes()).padStart(2, '0');
  return `${hours}:${minutes}z`;
};

const TopMenu = ({ user, view, onPageSelect, jsonData, filter, setFilter }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEventsOpen, setIsEventsOpen] = useState(false);
  const [utcTime, setUtcTime] = useState(formatUTCDate());
  const [activePage, setActivePage] = useState('Reservations');
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [events, setEvents] = useState([]);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);
  const openEvents = () => setIsEventsOpen(true);
  const closeEvents = () => setIsEventsOpen(false);
  const toggleFilter = () => setIsFilterOpen(!isFilterOpen);

  const fetchEvents = async () => {
    try {
        setLoading(true);
        const res = await fetch(DATA_URL + 'getAllEvents', { credentials: 'include' });
        if (!res.ok) throw new Error('Failed to fetch events');
        const data = await res.json();
        setEvents(data);
    } catch (err) {
        console.error('Error fetching events:', err);
    } finally {
        setLoading(false);
    }
  };

  useEffect(() => {
    fetchEvents();
  }, []);

  useEffect(() => {
    setUtcTime(formatUTCDate());

    const interval = setInterval(() => {
      setUtcTime(formatUTCDate());
    }, 60000); // Update every minute

    return () => {
      clearInterval(interval);
    };
  }, []);

  const handlePageSelect = (page) => {
    setActivePage(page);
    onPageSelect(page);
  };

  return (
    <div>
      {/* Top Menu */}
      <div className="top-menu">
        {/* Left side */}
        <Box className="top-menu-left">
          
          <div className={`filter-wrapper ${isFilterOpen ? 'open' : ''}`}>
            <TextField
              placeholder="Filter airspaces" variant="outlined" size="small" value={filter}
              onChange={(e) => setFilter(e.target.value)}
              
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start" sx={{ mr: 0 }}>
                    <IconButton onClick={() => setIsFilterOpen(!isFilterOpen)}>
                      <FilterListIcon />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </div>

          <span className='time-container'>
            <img src='images/time.svg' alt='Time'></img>
            <span>{utcTime}</span>
          </span>

        </Box>

        {/* Right side */}
        <Box className="top-menu-right">

        <Button onClick={openEvents} sx={{ minWidth: '30px', color: '#196D2', padding: '4px' }}>
          <EventIcon sx={{ fontSize: 26 }} />
            {events.filter(ev => !['Cancelled', 'Completed'].includes(ev.status)).length > 0 && (
                <span className="notification-count" style={{ top: '14px' }}>
                  {events.filter(ev => !['Cancelled', 'Completed'].includes(ev.status)).length}
                </span>
            )}
        </Button>

          <Button variant="contained" onClick={openModal} sx={{ lineHeight: 1, minHeight: 'auto', borderRadius: 0, height: '30px', fontSize: 12}}>
            Add reservation
          </Button>
        </Box>
      </div>

      <div style={{backgroundColor: '#fff', borderLeft: '1px solid #ddd', borderRight: '1px solid #ddd'}}>
        <span
          className={`page-selection ${activePage === 'Reservations' ? 'active-page-title' : ''}`}
          onClick={() => handlePageSelect('Reservations')}
        >
          Reservations
        </span>
        <span
          className={`page-selection ${activePage === 'Chart' ? 'active-page-title' : ''}`}
          onClick={() => handlePageSelect('Chart')}
        >
          Chart
        </span>
      </div>

      {/* Reservation Form */}
      {isModalOpen && (
        <ReservationForm
          user={user}
          view={view}
          isOpen={isModalOpen}
          onClose={closeModal}
          mode="create"
          onCreate={(reservation) => {
            closeModal();
          }}
          jsonData={jsonData}
        />
      )}

      {/* Events */}
      {isEventsOpen && (
        <Events
          user={user}
          view={view}
          isOpen={isEventsOpen}
          onClose={closeEvents}
          loading={loading}
          events={events}
          setEvents={setEvents}
          fetchEvents={fetchEvents}
        />
      )}
    </div>
  );
};

export default TopMenu;
